module.exports = __webpack_public_path__ + "static/img/mj2.ff2fd70b.png";